<template>
    <ChartBlock :data="data" v-if="isLoading" />
    <LoadingWrap v-else />
</template>

<script>
import { getDartData } from '@/api';
import ChartBlock from '@/components/ChartBlock.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';

export default {
    components: {
        ChartBlock,
        LoadingWrap
    },
    data() {
        return {
            isLoading: false,
            data: {
                unit: '원',
                step: 5000,
                type: [
                    {
                        name: '기본 주당순이익(EPS)',
                        type: 'bar',
                        color: '#f9cd5b',
                        data: [],
                    },
                    {
                        name: '주당순자산가치(BVPS)',
                        type: 'bar',
                        color: '#f56e4d',
                        data: [],
                    },
                    {
                        name: '주당매출액',
                        type: 'bar',
                        color: '#42c294',
                        data: [],
                    },
                ],
                years: [],
            },
        };
    },
    async mounted() {
        const {
            data: { SI },
        } = await getDartData();
        const modifyData = Object.keys(SI).reduce(
            (acc, key) => {
                Object.entries(SI[key]).forEach((entrie) => {
                    if (!acc.years.includes(entrie[0])) acc.years.push(entrie[0]);
                    if (!acc.type[key]) {
                        acc.type[key] = [entrie[1]];
                    } else {
                        acc.type[key].push(entrie[1]);
                    }
                });
                return acc;
            },
            {
                type: {},
                years: [],
            }
        );

        this.data.type[0].data = modifyData.type.eps; //기본 주당순이익(EPS)
        this.data.type[1].data = modifyData.type.bvps; //주당순자산가치(BVPS)
        this.data.type[2].data = modifyData.type.srps; //주당매출액
        this.data.years = modifyData.years;

        this.isLoading = true;
    },
};
</script>

<style></style>
